<style>
.role table  tr th{
  text-align: center;
}
.role table  td:nth-child(1){
  text-align: center;
}
</style>
<template>
  <div class="dynamic-tables">
    <Widget title="<h4>Tandatangan</h4>" collapse close customHeader>
      <b-tabs class="mb-lg">
          <b-tab title="Tanda Tangan" active>
              <div>
                <div class="form-group row">
                    <div class="col-sm-6">
                      <b-button variant="success" v-b-modal.modal-tambah><span class="glyphicon glyphicon-plus mb-2" /> Tambah
                      </b-button>
                    </div>
                    <div class="col-sm-6 text-end">
                    </div>
                  </div>
                  <div class="role">
                    <v-client-table :data="itemsWithNumber" :columns="columnsDatatable" :options="optionsRoles">
                        <div slot="file_ttd" slot-scope="props">
                            <a :href="props.row.file_ttd" target="_blank">
                                <b-img :src="props.row.file_ttd" style="height: 30px" target="_blank" fluid alt="Foto"></b-img>
                            </a>
                      </div>
                      <div slot="file_paraf" slot-scope="props">
                            <a :href="props.row.file_paraf" target="_blank">
                                <b-img :src="props.row.file_paraf" style="height: 30px" target="_blank" fluid alt="Foto"></b-img>
                            </a>
                      </div>
                      <div slot="aksi" slot-scope="props">
                        <b-button variant="info" class="me-3" size="s" @click="getDetail(props.row.id)">
                          <i class="glyphicon glyphicon-pencil text-white me-sm-1 mb-sm-2" />
                          <span class="d-none d-md-inline-block text-white"> Edit</span>
                        </b-button>
                        <b-button style="margin-left:5px" variant="danger" class="me-3" size="s" @click="deleteData(props.row.id)">
                          <i class="glyphicon glyphicon-trash text-white me-sm-1 mb-sm-2" />
                          <span class="d-none d-md-inline-block text-white"> Hapus</span>
                        </b-button>
                      </div>
                    </v-client-table>
                  </div>
              </div>
          </b-tab>

          <!-- Atribut -->
          <b-tab title="Jabatan">
              <div>
                <div class="form-group row">
                    <div class="col-sm-6">
                      <b-button variant="success" v-b-modal.modal-tambah-jabatan><span class="glyphicon glyphicon-plus mb-2" /> Tambah
                      </b-button>
                    </div>
                    <div class="col-sm-6 text-end">
                    </div>
                  </div>
                  <div class="role">
                    <v-client-table :data="itemsWithNumber2" :columns="columnsJabatan" :options="optionsRoles">
                        <div slot="file_ttd" slot-scope="props">
                            <a :href="props.row.file_ttd" target="_blank">
                                <b-img :src="props.row.file_ttd" style="height: 30px" target="_blank" fluid alt="Foto"></b-img>
                            </a>
                      </div>
                      <div slot="file_paraf" slot-scope="props">
                            <a :href="props.row.file_paraf" target="_blank">
                                <b-img :src="props.row.file_paraf" style="height: 30px" target="_blank" fluid alt="Foto"></b-img>
                            </a>
                      </div>
                      <div slot="aksi" slot-scope="props">
                        <b-button variant="info" class="me-3" size="s" @click="getDetailJabatan(props.row.id)">
                          <i class="glyphicon glyphicon-pencil text-white me-sm-1 mb-sm-2" />
                          <span class="d-none d-md-inline-block text-white"> Edit</span>
                        </b-button>
                        <b-button style="margin-left:5px" variant="danger" class="me-3" size="s" @click="deleteDataJabatan(props.row.id)">
                          <i class="glyphicon glyphicon-trash text-white me-sm-1 mb-sm-2" />
                          <span class="d-none d-md-inline-block text-white"> Hapus</span>
                        </b-button>
                      </div>
                    </v-client-table>
                  </div>
              </div>
          </b-tab>
    </b-tabs>
      
      </Widget>

    <!-- modal tambah ttd-->
    <b-modal body-class="bg-white" id="modal-tambah" title="Tambah Data" cancel-title="Close"
      ok-title="Accept" cancel-variant="outline-secondary">
      <form ref="form" @submit.stop.prevent="tambahdata" data-vv-scope="form-1">
        <b-row>
            <b-col md="12">
                <b-form-group label="Nama Lengkap" label-for="name" class="mb-3">
                    <b-form-input v-validate="'required'" name="nama lengkap"
                        :class="{ 'form-control': true, 'is-invalid': errors.has('form-1.nama lengkap') }" id="name" v-model="dataRoles.nama_lengkap" />
                    <span class="text-danger" v-if="errors.has('form-1.nama lengkap')">
                        {{ errors.first('form-1.nama lengkap') }}
                    </span>
                </b-form-group>
            </b-col>
            <b-col md="12">
                <b-form-group label="Nama Pendek" label-for="name" class="mb-3">
                    <b-form-input v-validate="'required'" name="nama pendek"
                        :class="{ 'form-control': true, 'is-invalid': errors.has('form-1.nama pendek') }" id="name" v-model="dataRoles.nama_pendek" />
                    <span class="text-danger" v-if="errors.has('form-1.nama pendek')">
                        {{ errors.first('form-1.nama pendek') }}
                    </span>
                </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group label="Jabatan: *" label-for="username">
                      <v-select
                              id="default-select"
                              label="nama_jabatan"
                              :reduce="jabatan => jabatan.id"
                              v-model="dataRoles.id_jabatan"
                              :options="dataJabatan"
                              v-validate="'required'" name="jabatan"
                              :class="{'is-invalid': errors.has('form-1.jabatan') }"
                          />
                      <span class="text-danger" v-if="errors.has('form-1.jabatan')">
                        {{ errors.first('form-1.jabatan') }}
                      </span>
                  </b-form-group>
            </b-col>
            <b-col md="12">
                  <b-form-group label="User: *" label-for="username">
                      <v-select
                              id="default-select"
                              label="nama"
                              :reduce="user => user.id"
                              v-model="dataRoles.id_user"
                              :options="dataUser"
                              v-validate="'required'" name="user"
                              :class="{'is-invalid': errors.has('form-1.user') }"
                          />
                      <span class="text-danger" v-if="errors.has('form-1.user')">
                        {{ errors.first('form-1.user') }}
                      </span>
                  </b-form-group>
                </b-col>
            <b-col md="12">
                  <b-form-group label="File TTD: *" label-for="username">
                    <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                v-model="dataRoles.file_ttd"
                                v-validate="'required'"
                                name="file ttd"
                                :class="{ 'is-invalid': errors.has('form-1.file ttd') }"
                                ></b-form-file>
                      <span class="text-danger" v-if="errors.has('form-1.file ttd')">
                        {{ errors.first('form-1.file ttd') }}
                      </span>
                  </b-form-group>
                </b-col>

                <b-col md="12">
                  <b-form-group label="File Paraf: *" label-for="username">
                    <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                v-model="dataRoles.file_paraf"
                                v-validate="'required'"
                                name="file paraf"
                                :class="{ 'is-invalid': errors.has('form-1.file paraf') }"
                                ></b-form-file>
                      <span class="text-danger" v-if="errors.has('form-1.file paraf')">
                        {{ errors.first('form-1.file paraf') }}
                      </span>
                  </b-form-group>
                </b-col>
        </b-row>

      </form>


      <template #modal-footer>
        <div class="w-100">
          <b-button variant="primary" style="float:right" @click="onSubmit">
            <i class="fa fa-floppy-o text-white" />
            <span class="text-white"> Simpan</span>
          </b-button>
        </div>
      </template>
    </b-modal>

    <!-- modal edit ttd -->
    <b-modal body-class="bg-white" id="modal-edit" title="Edit Data" cancel-title="Close" ok-title="Accept"
      cancel-variant="outline-secondary">
      <form ref="form" @submit.stop.prevent="tambahdata">
        <b-row>
            <b-col md="12">
                <b-form-group label="Nama Lengkap" label-for="name" class="mb-3">
                    <b-form-input v-validate="'required'" name="nama lengkap"
                        :class="{ 'form-control': true, 'is-invalid': errors.has('form-1.nama lengkap') }" id="name" v-model="dataRoles.nama_lengkap" />
                    <span class="text-danger" v-if="errors.has('form-1.nama lengkap')">
                        {{ errors.first('form-1.nama lengkap') }}
                    </span>
                </b-form-group>
            </b-col>
            <b-col md="12">
                <b-form-group label="Nama Pendek" label-for="name" class="mb-3">
                    <b-form-input v-validate="'required'" name="nama pendek"
                        :class="{ 'form-control': true, 'is-invalid': errors.has('form-1.nama pendek') }" id="name" v-model="dataRoles.nama_pendek" />
                    <span class="text-danger" v-if="errors.has('form-1.nama pendek')">
                        {{ errors.first('form-1.nama pendek') }}
                    </span>
                </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group label="Jabatan: *" label-for="username">
                      <v-select
                              id="default-select"
                              label="nama_jabatan"
                              :reduce="jabatan => jabatan.id"
                              v-model="dataRoles.id_jabatan"
                              :options="dataJabatan"
                              v-validate="'required'" name="jabatan"
                              :class="{'is-invalid': errors.has('form-1.jabatan') }"
                          />
                      <span class="text-danger" v-if="errors.has('form-1.jabatan')">
                        {{ errors.first('form-1.jabatan') }}
                      </span>
                  </b-form-group>
            </b-col>
            <b-col md="12">
                  <b-form-group label="User: *" label-for="username">
                      <v-select
                              id="default-select"
                              label="nama"
                              :reduce="user => user.id"
                              v-model="dataRoles.id_user"
                              :options="dataUser"
                              v-validate="'required'" name="user"
                              :class="{'is-invalid': errors.has('form-1.user') }"
                          />
                      <span class="text-danger" v-if="errors.has('form-1.user')">
                        {{ errors.first('form-1.user') }}
                      </span>
                  </b-form-group>
                </b-col>
            <b-col md="12">
                  <b-form-group label="File TTD: *" label-for="username">
                    <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                v-model="dataRoles.file_ttd"
                                v-validate="'required'"
                                name="file ttd"
                                :class="{ 'is-invalid': errors.has('form-1.file ttd') }"
                                ></b-form-file>
                      <span class="text-danger" v-if="errors.has('form-1.file ttd')">
                        {{ errors.first('form-1.file ttd') }}
                      </span>
                  </b-form-group>
                </b-col>

                <b-col md="12">
                  <b-form-group label="File Paraf: *" label-for="username">
                    <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                v-model="dataRoles.file_paraf"
                                v-validate="'required'"
                                name="file paraf"
                                :class="{ 'is-invalid': errors.has('form-1.file paraf') }"
                                ></b-form-file>
                      <span class="text-danger" v-if="errors.has('form-1.file paraf')">
                        {{ errors.first('form-1.file paraf') }}
                      </span>
                  </b-form-group>
                </b-col>
        </b-row>
      </form>


      <template #modal-footer>
        <div class="w-100">
          <b-button variant="primary" style="float:right" @click="editData(dataRoles.id)">
            <i class="fa fa-floppy-o text-white" />

            <span class="text-white"> Simpan</span>
          </b-button>
        </div>
      </template>
    </b-modal>

    <!-- modal tambah jabatan-->
    <b-modal body-class="bg-white" id="modal-tambah-jabatan" title="Tambah Data" cancel-title="Close"
      ok-title="Accept" cancel-variant="outline-secondary">
      <form ref="form" @submit.stop.prevent="tambahdata" data-vv-scope="form-1">
        <b-row>
            <b-col md="12">
                <b-form-group label="Nama Jabatan" label-for="name" class="mb-3">
                    <b-form-input v-validate="'required'" name="nama Jabatan"
                        :class="{ 'form-control': true, 'is-invalid': errors.has('form-1.nama Jabatan') }" id="name" v-model="detailJabatan.nama_jabatan" />
                    <span class="text-danger" v-if="errors.has('form-1.nama Jabatan')">
                        {{ errors.first('form-1.nama Jabatan') }}
                    </span>
                </b-form-group>
            </b-col>
            <b-col md="12">
                <b-form-group label="Nama Jabatan Pendek" label-for="name" class="mb-3">
                    <b-form-input v-validate="'required'" name="nama Jabatan Pendek"
                        :class="{ 'form-control': true, 'is-invalid': errors.has('form-1.nama Jabatan Pendek') }" id="name" v-model="detailJabatan.nama_jabatan_pendek" />
                    <span class="text-danger" v-if="errors.has('form-1.nama Jabatan Pendek')">
                        {{ errors.first('form-1.nama Jabatan Pendek') }}
                    </span>
                </b-form-group>
            </b-col>
        </b-row>
      </form>

      <template #modal-footer>
        <div class="w-100">
          <b-button variant="primary" style="float:right" @click="onSubmitJabatan">
            <i class="fa fa-floppy-o text-white" />
            <span class="text-white"> Simpan</span>
          </b-button>
        </div>
      </template>
    </b-modal>

    <!-- modal edit jabatan -->
    <b-modal body-class="bg-white" id="modal-edit-jabatan" title="Edit Data" cancel-title="Close"
      ok-title="Accept" cancel-variant="outline-secondary">
      <form ref="form" @submit.stop.prevent="tambahdata" data-vv-scope="form-1">
        <b-row>
            <b-col md="12">
                <b-form-group label="Nama Jabatan" label-for="name" class="mb-3">
                    <b-form-input v-validate="'required'" name="nama Jabatan"
                        :class="{ 'form-control': true, 'is-invalid': errors.has('form-1.nama Jabatan') }" id="name" v-model="detailJabatan.nama_jabatan" />
                    <span class="text-danger" v-if="errors.has('form-1.nama Jabatan')">
                        {{ errors.first('form-1.nama Jabatan') }}
                    </span>
                </b-form-group>
            </b-col>
            <b-col md="12">
                <b-form-group label="Nama Jabatan Pendek" label-for="name" class="mb-3">
                    <b-form-input v-validate="'required'" name="nama Jabatan Pendek"
                        :class="{ 'form-control': true, 'is-invalid': errors.has('form-1.nama Jabatan Pendek') }" id="name" v-model="detailJabatan.nama_jabatan_pendek" />
                    <span class="text-danger" v-if="errors.has('form-1.nama Jabatan Pendek')">
                        {{ errors.first('form-1.nama Jabatan Pendek') }}
                    </span>
                </b-form-group>
            </b-col>
        </b-row>
      </form>

      <template #modal-footer>
        <div class="w-100">
          <b-button variant="primary" style="float:right" @click="editDataJabatan(detailJabatan.id)">
            <i class="fa fa-floppy-o text-white" />
            <span class="text-white"> Simpan</span>
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
  
<script>
import Widget from '@/components/Widget/Widget';
import axios from 'axios';
import vSelect from 'vue-select';
import Swal from 'sweetalert2'

export default {
  name: 'Dynamic',
  components: { Widget, vSelect },
  data() {
    return {
      baseapi: localStorage.getItem("baseapi"),
      user: JSON.parse(localStorage.getItem('user')),
      columnsDatatable: ['no', 'file_ttd','file_paraf','nama_lengkap', 'jabatan', 'aksi'],
      columnsJabatan: ['no', 'nama_jabatan','nama_jabatan_pendek', 'aksi'],
      dataUser: [],
      dataRoles: [],
      dataRole: [],
      dataJabatan: [],
      detailJabatan: [],
      optionsRoles: {
        perPage: 10,
        pagination: { chunk: 10, dropdown: false },
        texts: { filter: '', count: '', limit: '' },
        columnsClasses: { no: 'width-100' },
        skin: 'table table-striped',
        sortIcon: {
          base: 'fa text-muted', up: 'fa-chevron-up', down: 'fa-chevron-down', is: 'fa-sort',
        },
      },
      fields: [
            'no',
            { key: "file_ttd", label: "TTD" },
            { key: "file_paraf", label: "Paraf" },
            { key: "nama_lengkap", sortable: true, label: "nama"  },
            { key: "jabatan", sortable: true },
            'Aksi',
        ],
      dataUser:[]
    };
  },
  mounted() {
    this.getDataUser()
    this.loaddata()
    this.loaddataJabatan()
  },
  computed: {
      itemsWithNumber() {
        return this.dataRole.map((d, index) => ({ ...d, no: index + 1 }))
      },
      itemsWithNumber2() {
        return this.dataJabatan.map((d, index) => ({ ...d, no: index + 1 }))
      }
  },
  methods: {
    deleteData(id) {
        Swal.fire({
            title: 'Hapus Data?',
            // text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya'
            }).then((result) => {
            if (result.isConfirmed) {
                axios
                    .delete(
                    this.baseapi + `api/tandatangan/` + id,
                    {
                        headers: {
                        Authorization: `Bearer ` + this.user.accessToken
                        }
                    }
                    )
                    .then((res) => {
                    this.$toasted.success("Berhasil Dihapus");
                    this.loaddata()
                    return res;
                    })
                    .catch((err) => {
                    console.log(err)
                    this.$toasted.error(err.response.data.message);
                    return err;
                    });
            }
    })
    },

    deleteDataJabatan(id) {
        Swal.fire({
            title: 'Hapus Data?',
            // text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya'
            }).then((result) => {
            if (result.isConfirmed) {
                axios
                    .delete(
                    this.baseapi + `api/jabatan/` + id,
                    {
                        headers: {
                        Authorization: `Bearer ` + this.user.accessToken
                        }
                    }
                    )
                    .then((res) => {
                    this.$toasted.success("Berhasil Dihapus");
                    this.loaddataJabatan()
                    return res;
                    })
                    .catch((err) => {
                    console.log(err)
                    this.$toasted.error(err.response.data.message);
                    return err;
                    });
            }
    })
    },
    getDataUser() {
          axios.get(this.baseapi + "api/user", {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken
            }
          }).then(response => {
            this.dataUser = response.data.data;
          }).catch(error => {
            console.log(error)
            return error
          });
        },

    onSubmit() {
      this.$validator.validateAll('form-1').then((result) => {
        if (result) {
            let formData = new FormData();
                formData.append('nama_lengkap', this.dataRoles.nama_lengkap);
                formData.append('nama_pendek', this.dataRoles.nama_pendek);
                formData.append('id_jabatan', this.dataRoles.id_jabatan);
                formData.append('file_ttd', this.dataRoles.file_ttd);
                formData.append('file_paraf', this.dataRoles.file_paraf);
                formData.append('id_user', this.dataRoles.id_user);
                
                // tampak_depan
          axios.post(this.baseapi + 'api/tandatangan', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: `Bearer ` + this.user.accessToken
            }
          })
            .then((res) => {
              this.$toasted.success("Berhasil Ditambah");
              this.loaddata()
              this.dataRoles = []

              // Wait until the models are updated in the UI
              this.$nextTick(() => {
                this.$bvModal.hide('modal-tambah')
              });
              return res;
            })
            .catch((err) => {
              console.log(err)
              this.$toasted.error(err.response.data.message);
              return err;
            });
        }
      })
    },

    editData(id) {
        this.$validator.validateAll('form-1').then((result) => {
        if (result) {
            let formData = new FormData();
                formData.append('nama_lengkap', this.dataRoles.nama_lengkap);
                formData.append('nama_pendek', this.dataRoles.nama_pendek);
                formData.append('id_jabatan', this.dataRoles.id_jabatan);
                formData.append('file_ttd', this.dataRoles.file_ttd);
                formData.append('file_paraf', this.dataRoles.file_paraf);
                formData.append('id_user', this.dataRoles.id_user);
                
                // tampak_depan
          axios.post(this.baseapi + 'api/tandatangan/'+id, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: `Bearer ` + this.user.accessToken
            }
          })
            .then((res) => {
              this.$toasted.success("Berhasil Diubah");
              this.loaddata()
              this.dataRoles = []

              // Wait until the models are updated in the UI
              this.$nextTick(() => {
                this.$bvModal.hide('modal-edit')
              });
              return res;
            })
            .catch((err) => {
              console.log(err)
              this.$toasted.error(err.response.data.message);
              return err;
            });
        }
      })
    },

    // simpaan Jabatan
    onSubmitJabatan() {
      this.$validator.validateAll('form-1').then((result) => {
        if (result) {
          axios.post(this.baseapi + 'api/jabatan', {
            nama_jabatan: this.detailJabatan.nama_jabatan,
            nama_jabatan_pendek: this.detailJabatan.nama_jabatan_pendek,
            },{
            headers: {
              Authorization: `Bearer ` + this.user.accessToken
            }
          }
          )
            .then((res) => {
              this.$toasted.success("Berhasil Ditambah");
              this.loaddataJabatan()
              this.detailJabatan = []

              // Wait until the models are updated in the UI
              this.$nextTick(() => {
                this.$bvModal.hide('modal-tambah-jabatan')
              });
              return res;
            })
            .catch((err) => {
              console.log(err)
              this.$toasted.error(err.response.data.message);
              this.$nextTick(() => {
                this.$bvModal.hide('modal-tambah-jabatan')
              });
              return err;
            });
        }
      })
    },

    // loaddata user
    loaddata() {
      axios.get(this.baseapi + "api/tandatangan", {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken
        }
      }).then(response => {
        this.dataRole = response.data.data;
      }).catch(error => {
        console.log(error)
        return error
      });
    },

    loaddataJabatan() {
      axios.get(this.baseapi + "api/jabatan", {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken
        }
      }).then(response => {
        this.dataJabatan = response.data.data;
      }).catch(error => {
        console.log(error)
        return error
      });
    },

    // detail
    getDetail(id) {
      axios.get(this.baseapi + "api/tandatangan/" + id, {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken
        }
      }).then(response => {
        this.dataRoles = response.data.data;
        this.$nextTick(() => {
          this.$bvModal.show('modal-edit')
        });
      }).catch(error => {
        console.log(error)
        return error
      });
    },

    // detail
    getDetailJabatan(id) {
      axios.get(this.baseapi + "api/jabatan/" + id, {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken
        }
      }).then(response => {
        this.detailJabatan = response.data.data;
        this.$nextTick(() => {
          this.$bvModal.show('modal-edit-jabatan')
        });
      }).catch(error => {
        console.log(error)
        return error
      });
    },

    editDataJabatan(id) {
      this.$validator.validateAll();
      axios
        .put(
          this.baseapi + `api/jabatan/${id}`,
          {
            nama_jabatan: this.detailJabatan.nama_jabatan,
            nama_jabatan_pendek: this.detailJabatan.nama_jabatan_pendek,
          }
          , {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken
            }
          })
        .then((res) => {
          this.$toasted.success("Berhasil Diubah");
          this.detailJabatan = []
          this.loaddataJabatan()

          this.$nextTick(() => {
            this.$bvModal.hide('modal-edit-jabatan')
          })
          return res;
        })
        .catch((err) => {
          console.log(err)
          this.$toasted.error(err.response.data.message);
          return err;
        });
    },
  },
};
</script>
  
  

<style src="./Tandatangan.scss" lang="scss" />
  